/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unknown_OrganiserInputs */

const th_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ทราบผู้จัด`)
};

const en_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown organiser`)
};

const ja_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主催者不明`)
};

const zh_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主办方不详`)
};

const es_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizador desconocido`)
};

const pt_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizador desconhecido`)
};

const id_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyelenggara tidak diketahui`)
};

const fr_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisateur inconnu`)
};

const tl_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di-kilalang organizer`)
};

const vi_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không rõ ban tổ chức`)
};

const ko_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주최자 미상`)
};

const de_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannter Veranstalter`)
};

const ru_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Организатор неизвестен`)
};

const tr_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düzenleyen bilinmiyor`)
};

const it_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizzatore sconosciuto`)
};

const pl_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieznany organizator`)
};

const uk_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Організатор невідомий`)
};

const hi_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजक अज्ञात`)
};

const ar_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنظّم غير معروف`)
};

const ms_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penganjur tidak diketahui`)
};

const bn_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজক অজানা`)
};

const zh_tw2_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主辦單位不詳`)
};

const zh_hk2_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主辦單位不詳`)
};

const ur_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منتظم نامعلوم`)
};

const fa_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برگزارکننده نامشخص`)
};

const sw_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwandalizi hajulikani`)
};

const nl_unknown_organiser = /** @type {(inputs: Unknown_OrganiserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisator onbekend`)
};

/**
* | output |
* | --- |
* | "Unknown organiser" |
*
* @param {Unknown_OrganiserInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const unknown_organiser = /** @type {((inputs?: Unknown_OrganiserInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unknown_OrganiserInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_unknown_organiser(inputs)
	if (locale === "ja") return ja_unknown_organiser(inputs)
	if (locale === "zh") return zh_unknown_organiser(inputs)
	if (locale === "es") return es_unknown_organiser(inputs)
	if (locale === "pt") return pt_unknown_organiser(inputs)
	if (locale === "id") return id_unknown_organiser(inputs)
	if (locale === "fr") return fr_unknown_organiser(inputs)
	if (locale === "tl") return tl_unknown_organiser(inputs)
	if (locale === "vi") return vi_unknown_organiser(inputs)
	if (locale === "ko") return ko_unknown_organiser(inputs)
	if (locale === "de") return de_unknown_organiser(inputs)
	if (locale === "ru") return ru_unknown_organiser(inputs)
	if (locale === "tr") return tr_unknown_organiser(inputs)
	if (locale === "it") return it_unknown_organiser(inputs)
	if (locale === "pl") return pl_unknown_organiser(inputs)
	if (locale === "uk") return uk_unknown_organiser(inputs)
	if (locale === "hi") return hi_unknown_organiser(inputs)
	if (locale === "ar") return ar_unknown_organiser(inputs)
	if (locale === "ms") return ms_unknown_organiser(inputs)
	if (locale === "bn") return bn_unknown_organiser(inputs)
	if (locale === "zh-TW") return zh_tw2_unknown_organiser(inputs)
	if (locale === "zh-HK") return zh_hk2_unknown_organiser(inputs)
	if (locale === "ur") return ur_unknown_organiser(inputs)
	if (locale === "fa") return fa_unknown_organiser(inputs)
	if (locale === "sw") return sw_unknown_organiser(inputs)
	if (locale === "nl") return nl_unknown_organiser(inputs)
	return en_unknown_organiser(inputs)
});